export const CONNECTED_CHAIN = 'Blast Sepolia'
export const CONNECTED_CHAIN_ID = "blast-sepolia";
export const CONNECTED_CHAIN_EXPLORER = "https://testnet.blastscan.io";